import { render, staticRenderFns } from "./news3.vue?vue&type=template&id=a4d32d3a&"
var script = {}
import style0 from "./news3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "news3.vue"
export default component.exports